console.log('Gornitsa Theme Loaded Successfully');

// Add interactive logic here if required
document.addEventListener("DOMContentLoaded", () => {
    // Basic interaction code could go here
});
